<template>
  <div class="language-switcher">
    <button
      v-for="locale in availableLocales"
      :key="locale"
      @click="switchLanguage(locale)"
      :class="{ active: currentLocale === locale }"
    >
      {{ locale === 'ar' ? 'عر' : 'Fr' }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed, onMounted } from 'vue'

const { locale, availableLocales } = useI18n()

const currentLocale = computed(() => locale.value)

const switchLanguage = (newLocale) => {
  locale.value = newLocale
  document.dir = newLocale === 'ar' ? 'rtl' : 'ltr'
  localStorage.setItem('user-locale', newLocale)
}

onMounted(() => {
    // Initial setup from localStorage if available
    const savedLocale = localStorage.getItem('user-locale')
    if (savedLocale && availableLocales.includes(savedLocale)) {
        locale.value = savedLocale
        document.dir = savedLocale === 'ar' ? 'rtl' : 'ltr'
    } else {
        document.dir = locale.value === 'ar' ? 'rtl' : 'ltr'
    }
})

</script>

<style scoped>
.language-switcher {
  display: flex;
  gap: 8px;
  align-items: center;
  direction: ltr; /* Force LTR layout for buttons regardless of document direction */
}

button {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}

button:hover {
  color: #1e293b;
  background-color: #f1f5f9;
}

button.active {
  background-color: #1e293b; /* Dark minimalistic active state */
  color: white;
  border-color: #1e293b;
}
</style>
